import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {IconColors} from '@techsee/techsee-ui-common/lib/icons/large-rounded-icon';
import {GuidenceProgressItem} from '../components/guidance-progress/GuidanceProgress';
import {ProgressList} from '../components/progress-list/ProgressList';
import {InviteStepsLayout} from './_Shared';
import {AgentGuidance} from '../components/agent-guidance/AgentGuidance';
import {InviteStepProps} from './_InviteGenericStep';
import {SimpleTabs, ITab} from '@techsee/techsee-ui-common/lib/tabs/simple';
import {InviteDeviceType} from '../../_contracts/InviteContracts';

@observer
export class VideoApplicationGuidanceCameraDialogStep extends TechseeBaseComponent<InviteStepProps> {
    componentDidMount() {
        this.props.ctrl.setPagePlacement('camera-audio-permission-video-application');
    }

    get progressItems(): GuidenceProgressItem[] {
        const {translate} = this.props.ctrl;

        return [
            {
                iconColor: IconColors.Green,
                label: translate('REACT.INVITE.PERMISSIONS.VIDEO_APPLICATION.USER_PERMISSION'),
                isActive: false,
                icon: 'check',
                isIconAnimated: false,
                iconNoBorder: true
            },
            {
                iconColor: IconColors.Blue,
                label: translate('REACT.INVITE.PERMISSIONS.VIDEO_APPLICATION.CAMERA_MICROPHONE_PERMISSION'),
                isActive: true,
                icon: 'camera',
                isIconAnimated: false,
                iconNoBorder: true
            }
        ];
    }

    getTab(device: InviteDeviceType) {
        const {progressItems} = this;
        const {translate} = this.props.ctrl;

        if (device === InviteDeviceType.ios) {
            return () => (
                <div className={'guidance-progress row'}>
                    <div className={'col-left col-sm-4'}>
                        <ProgressList progressList={progressItems} />
                    </div>
                    <div className={'col-left col-sm-6 mid-col'}>
                        <AgentGuidance
                            stepType={'video-application'}
                            stepNum={1}
                            deviceType={device}
                            stepText={translate(
                                'REACT.INVITE.PERMISSIONS.VIDEO_APPLICATION.USER_PERMISSIONS_GUIDE_IOS_ONE'
                            )}
                            tooltipPosition={{
                                top: '68%',
                                left: '26%'
                            }}
                        />
                        <AgentGuidance
                            stepType={'video-application'}
                            stepNum={2}
                            deviceType={InviteDeviceType.android}
                            stepText={translate(
                                'REACT.INVITE.PERMISSIONS.VIDEO_APPLICATION.USER_PERMISSIONS_GUIDE_ANDROID_TWO'
                            )}
                            tooltipPosition={{
                                top: '68%',
                                left: '62%'
                            }}
                        />
                    </div>
                </div>
            );
        }

        if (device === InviteDeviceType.android) {
            return () => (
                <div className={'guidance-progress row'}>
                    <div className={'col-left col-sm-4'}>
                        <ProgressList progressList={progressItems} />
                    </div>
                    <div className={'col-left col-sm-6 mid-col'}>
                        <AgentGuidance
                            stepType={'video-application'}
                            stepNum={1}
                            deviceType={device}
                            stepText={translate(
                                'REACT.INVITE.PERMISSIONS.VIDEO_APPLICATION.USER_PERMISSIONS_GUIDE_ANDROID_ONE'
                            )}
                            tooltipPosition={{
                                top: '12%',
                                left: '11%'
                            }}
                        />
                        <AgentGuidance
                            stepType={'video-application'}
                            stepNum={2}
                            deviceType={device}
                            stepText={translate(
                                'REACT.INVITE.PERMISSIONS.VIDEO_APPLICATION.USER_PERMISSIONS_GUIDE_ANDROID_TWO'
                            )}
                            tooltipPosition={{
                                top: '68%',
                                left: '62%'
                            }}
                        />
                    </div>
                    <div className={'col-left col-sm-4'}>&nbsp;</div>
                </div>
            );
        }

        return () => <React.Fragment />;
    }

    renderInternal() {
        const {translate} = this.props.ctrl;
        const _clientDeviceType = this.props.ctrl.clientDeviceType;
        const tabsList: ITab[] = [
            {
                title: InviteDeviceType.android,
                content: this.getTab(InviteDeviceType.android)
            },
            {
                title: InviteDeviceType.ios,
                content: this.getTab(InviteDeviceType.ios)
            }
        ];

        if (_clientDeviceType === InviteDeviceType.common) {
            return <React.Fragment />;
        }

        return (
            <InviteStepsLayout
                className={'screen-share-step'}
                h1Text={translate('REACT.INVITE.PERMISSIONS.SCREEN_SHARE.USER_PERMISSIONS')}
                h2Text={translate('REACT.INVITE.PERMISSIONS.VIDEO_APPLICATION.USER_PERMISSIONS_GUIDE')}>
                <SimpleTabs
                    key={this.props.ctrl.getSelectedDeviceTabIndex}
                    tabsList={tabsList}
                    uid={'screen-share-tabs'}
                    initialTabIndex={this.props.ctrl.getSelectedDeviceTabIndex}
                    onChange={this.props.ctrl.onDeviceTabChange}
                />
            </InviteStepsLayout>
        );
    }
}
